import React from 'react';
import { RenderingWarning } from 'components/Collection/RenderingWarning';
import { GribblePreviewCard } from './PreviewCard';
import styles from './GribbleAside.module.scss';
import { RevealedGribble } from './state-machine';

type GribbleAsideProps = {
  currentGribble: RevealedGribble;
  image: string;
};

export const GribbleAside = ({ currentGribble, image }: GribbleAsideProps) => (
  <aside className={styles.gribbleCard}>
    <GribblePreviewCard id={currentGribble.id} image={image} />
    <div className={styles.renderingWarningContainer}>
      <RenderingWarning hatchStartedAt={currentGribble.hatchStartedAt} />
    </div>
  </aside>
);
